// 四捨五入
function orgFloor(value: number, base: number) {
  return Math.floor(value * base) / base;
}

// 12345678 => 1234.5678 => 1235
function yenToManyen(value: number, decimal_place: number) {
  return orgFloor(value / 10000, Math.pow(10, decimal_place));
}

// 12345678 => 1,234
export function yenToManString(value: number, decimal_place: number) {
  return yenToManyen(value, decimal_place).toFixed(decimal_place);
}


// Math.round(x: number) // 四捨五入
// Math.ceil(x: number); // 切り上げ
// Math.floor(x: number); // 切り捨て
export function yenToManOkuString(yen: number){
    const okuyen_floor = Math.floor(yen/(10000**2))
    const manyen_round = Math.round(yen/(10000))-okuyen_floor*10000
    
    if(manyen_round < 1){
      return yen.toLocaleString()
    }
    if(okuyen_floor < 1){
      return manyen_round.toLocaleString()
    }
    return okuyen_floor.toString()+"億"+manyen_round.toLocaleString()

}

// 12345678 => 1,234,5678
export function yenToString(value: number) {
  return value.toLocaleString();
}
